export const version = 'kunde-v1.15.0-SNAPSHOT-a11216f1618506a59bb97b9babc435a033e2d6b9';